import { ProcessGeneral } from 'api/endpoints/processes';

export function hasGeneralPayablesLicense(draft?: ProcessGeneral) {
  return draft?._links?.['searchGeneralPayablesScenarios'] !== undefined;
}
